module.exports = __webpack_public_path__ + "media/packs/base/stylesheets/fonts/apercu-regular-pro-94324c074ea36cc00f997459db614ffd.eot";